fx.ns("shared.stage", class Frame extends fx.Component {

    constructor(model)
    {
        super();

        this.pointerEvents = false;

        this.model = model;
    }


    get model()
    {
        return this._model;
    }

    set model(val)
    {
        this._model = val;
    }

    onReady()
    {
        super.onReady();

        this.width(0);
        this.height(0);
        
        //this.border = this.find(".border");
        /*this.borderTop =  this.find(".top");
        this.borderLeft =  this.find(".left");
        this.borderRight =  this.find(".right");
        this.borderBottom =  this.find(".bottom");*/

        this.on("resize", this._windowResized, window);
    }

    get border()
    {
       return this.find(".border"); 
    }

    get currentElement()
    {
        return this._currentElement;
    }

    set currentElement(val)
    {
        if (this._currentElement && this._currentElement == val)
            return;
            
        if (this._currentElement && this._currentElement.selectable)
            this.off("updated", this.dataUpdated, this.currentElement.data);

        this._currentElement = val;

        //this.currentArea = (this._currentElement && this._currentElement.parent ? (this._currentElement.parent.parent instanceof shared.stage.Area ? this._currentElement.parent.parent : this._currentElement.parent) : null);
        
        if (this._currentElement && this._currentElement.selectable)
            this.on("updated", this.dataUpdated, this._currentElement.data);
    
        //this.updateDisplay();

        
        this.resize();
        this.position();
    }

    get currentArea()
    {
        return this._currentArea;
    }

    set currentArea(val)
    {
        this._currentArea = val;
    }

    get currentStage()
    {
        return this.currentArea instanceof shared.stage.Stage ? this.currentArea : this.currentArea.stage;
    }

    show()
	{
        if (this.model.zoom.value < 100 && fx.get("app-mode") != "touch")
			return;

        if (!this._currentElement)
            return;
            
		super.show();
	}

    dataUpdated(e)
    {
        if (e && e.action.type=="delete" && this.currentElement /*&& !this.currentElement.data*/)
            this.currentElement = null;
        else
        if (e.action.impacts("width", "height", "x", "y") || e.action.tag == "resize")
            this.position(e);
    }

    onDisplayUpdated()
    {
        this.position();
    }

    /**
	 * We override this function, so we can move up ToolBar when hidden.
	 * In order to avoid bug Board on scrollHeight (zoom 25%)
	 */
	hide()
	{
        if (this.visible)
        {
		    super.hide();
		    this.css({ transform : "", left: 0, top: 0});
        }
	}

    resize()
    {
        if (this.currentElement)
            super.resize();
    }

    position(e)
    {
        if (this.currentElement && typeof this.currentElement == "object"  && this.currentArea && typeof this.currentArea == "object" && ((this.currentElement.selectable && this.currentElement.editable) || this.currentElement.hoverable ) )
        {
            // TODO : use zoom for safari
            this.css( { 
                        transform: this.currentArea.css("transform"),
                        zoom : this.currentArea.css("zoom"),
                        top : 0,
                        left : 0
                      } );
            
            this.css(this.border, { top : this.currentElement.y, 
                                    left : this.currentElement.x + parseFloat(this.currentStage.css("left")), // because 1st backcover is shifted
                                    transform: "rotate(" + this.currentElement.rotation + "deg) translate3d(0px, 0px, 0px)", 
                                    width : this.currentElement.width /*- 1/ this.currentArea.scale*/, 
                                    height :this.currentElement.height /*- 1/ this.currentArea.scale*/    });
            
            // We add a delay here, so in case of many call, only the last one is taken into account
            this.delay(this.show);
        }
        else
        {
            this.hide();
        }
    }

    
    onDataUpdated(action)
    {
        if (action.type == "init")
            super.onDataUpdated(action);
    }

    _windowResized()
    {
        if (fx.browser.isMobile || fx.browser.isTablet)
            this.delay(this.position, 250); // on mobile version, keyboard
    }


    render()
    {
        let html = '<div class="border">';
        /*html += '<div class="side top" style=""></div>';
        html += '<div class="side left" style=""></div>';
        html += '<div class="side right" style=""></div>';
        html += '<div class="side bottom" style=""></div>';*/   
        html += '</div>';
        return html;
    }

    destroy()
    {
        super.destroy();

        this.currentElement = null;
        //this.border = null;
       /* this.borderTop =  null;
        this.borderLeft =  null;
        this.borderRight =  null;
        this.borderBottom =  null;*/
    }
});